import React from 'react';
import PropTypes from 'prop-types';
import styles from './PropertyPrice.module.css';
import moment from 'moment';
 

// Class applied to the price value itself, so exact prices, price
// ranges and "no price" (POA) all read with the same emphasis.
const PRICE_CLASS = 'tw-text-primary tw-text-2xl';

const PropertyPrice = ({ item, dictionary }) => {
  const price = item.Price;
  const start = moment(item.SearchStart);
  const end = moment(item.SearchEnd);
  const nights = +end.diff(start, 'days') || 7;

  // Values that templates can reference via {price}, {nights}, {date}.
  // The price value is the one we style; the rest are plain text.
  const tokens = {
    '{price}': <span key="price" className={PRICE_CLASS}>{price}</span>,
    '{nights}': nights,
    '{date}': start.format('Do MMM YYYY'),
  };

  const priceToken = dictionary ? dictionary[item.WhatPriceTokenToUse] : undefined;

  let content;
  if (priceToken === undefined) {
    // No price template (e.g. POA / "N/A") — show the raw price value,
    // styled the same as a templated price for visual consistency.
    content = tokens['{price}'];
  } else {
    // Split on the known placeholders (keeping them) and swap each one
    // for its value. Anything else passes through as plain text, so no
    // backend string is ever interpreted as HTML.
    content = priceToken
      .split(/(\{price\}|\{nights\}|\{date\})/g)
      .filter((part) => part !== '')
      .map((part, i) =>
        part in tokens
          ? <React.Fragment key={i}>{tokens[part]}</React.Fragment>
          : <React.Fragment key={i}>{part}</React.Fragment>
      );
  }

  return (
    <div className={styles.PropertyPrice}>
      <div className="tw-text-[1.5rem] tw-mb-3">{content}</div>
    </div>
  );
};

PropertyPrice.propTypes = {};

PropertyPrice.defaultProps = {};

export default PropertyPrice;
